module.exports = __webpack_public_path__ + "img/popupTitle4.e07eb656.png";